import type { ReactNode } from 'react';

export type RouteArea = 'public' | 'expert' | 'manager' | 'operations' | 'admin';
export type RouteGuard = 'public' | 'private' | 'expert' | 'manager' | 'operations' | 'admin' | 'inherited';
export type RouteLayout = 'public' | 'shell' | 'full-width' | 'full-height';
export type RouteKind = 'layout' | 'page' | 'redirect';

export interface RouteMetadata {
  id: string;
  path: string;
  area: RouteArea;
  guard: RouteGuard;
  layout: RouteLayout;
  kind: RouteKind;
  parentId?: string;
  redirectTo?: string;
}

export interface AppRoute {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  handle: RouteMetadata;
  children?: AppRoute[];
}

export function defineRoute(handle: RouteMetadata, route: Omit<AppRoute, 'handle'>): AppRoute {
  return { ...route, handle };
}

export function flattenRouteMetadata(routes: AppRoute[]): RouteMetadata[] {
  return routes.flatMap((route) => [route.handle, ...(route.children ? flattenRouteMetadata(route.children) : [])]);
}
